import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const ServiceState = {
  state: {},
  getters,
  mutations,
  actions
}

export default ServiceState